// src/services/ProductService.js
import { secureGet } from '../utils/apiClient';

export const ProductService = {
  /**
   * Fetch EWE products with pagination and sorting
   */
  fetchEweProducts: async (params = {}) => {
     try {
       const response = await secureGet('/api/ewe/products', {
         page: params.page || 0,
         size: params.size || 100,
         sort: params.sort || 'productKey,desc',
         ...params.filter
       });

       return {
         products: response.content || [],
         totalPages: response.totalPages || 1,
         totalElements: response.totalElements || 0
       };
     } catch (error) {
       console.error('Failed to fetch EWE products:', error);
       return { products: [], totalPages: 0, totalElements: 0 };
     }
   },

  /**
   * Fetch categories
   */
  fetchCategories: async () => {
    try {
      const response = await secureGet('/api/ewe/products/categories');
      return Array.isArray(response) ? response : [];
    } catch (error) {
      console.error('Failed to fetch categories:', error);
      return [];
    }
  },

  /**
   * Get product details
   */
  getEweProductDetails: async (productKey) => {
    try {
      const response = await secureGet(`/api/ewe/products/${productKey}`);

      // Transform specification data
const specifications = response.specification?.flatMap(group =>
  (group.filters || []).map(filter => ({
    group: group.acGroupName || 'Uncategorized',
    name: filter.acFilterSet || 'Attribute',
    value: filter.filters || 'N/A'
  }))
) || [];

      return {
        ...response,
        specifications,
        images: response.urlImages?.map(img => ({
          id: img.url,  // or generate a unique ID if needed
          url: img.url,  // changed from imageUrl to url
          thumbnailUrl: img.thumbnailUrl
        })) || []
      };
    } catch (error) {
      console.error('Failed to fetch product details:', error);
      return null;
    }
  },

  /**
   * Transform product format for frontend consistency
   */
  transformEweProduct: (eweProduct) => ({
    id: eweProduct.productKey?.toString() || '',
    name: eweProduct.acName || 'Unnamed Product',
    code: eweProduct.acProduct || 'N/A',
    price: eweProduct.anPrice || 0,
    retailPrice: eweProduct.anRetailPrice || 0,
    stock: eweProduct.anStock || 0,
    discount: eweProduct.anDiscount || 0,
    isPromo: eweProduct.isPromotion === 1,
    category: {
      id: eweProduct.anCategoryKey || 0,
      name: eweProduct.acCategory || 'Uncategorized',
      parentId: eweProduct.anMainCategoryKey || 0
    },
    brand: eweProduct.acSupplier || 'Generic Brand',
    model: eweProduct.acModel || '',
    imageUrls: eweProduct.imageUrls || [],
attributes: eweProduct.specification?.flatMap(group =>
  (group.filters || []).map(filter => ({
    key: filter.acFilterSet || 'Attribute',
    value: filter.filters || 'N/A'
  }))
) || []
}),
  /**
   * Delete product
   */
  removeProduct: async (id) => {
    try {
      await secureGet(`/api/ewe/products/delete/${id}`);
      return true;
    } catch (error) {
      console.error('Failed to delete product:', error);
      return false;
    }
  }
};